import { FontWeights, makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  modalContainerW1200: {
    width: 1200,
    height: '90vh',
    overflow: 'hidden',
  },
  modalContainerW600: {
    width: 700,
    height: 600,
    overflow: 'hidden',
  },

  noScrollContainer: {
    overflow: 'hidden',
  },
  buttonStyle: {
    position: 'absolute',
    bottom: 20,
    left: '40%',
    width: '100%',
  },
  containerStyle: {
    position: 'absolute',
    top: 50,
    bottom: 80,
    overflow: 'hidden',
    width: `calc(100% - 30px)`,
  },
  headerStyle: {
    position: 'sticky',
    top: 20,
    left: 20,
    width: '100%',
  },
}));
